import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import system from './modules/system'
import district from './modules/district'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.VUE_APP_ENV !== 'production',
  modules: {
    user,
    system,
    district,
  },
  getters,
})
